import TablePageFooter from './table-page-footer/table-page-footer.js'
import { TableContainer } from './table-container/table-container.component.styles.js'
import { SPACING } from 'ggx-componentlibrary/design/spacing/spacing.constants'

export default {
  TableContainer,
  TablePageFooter,
  FABPosition: {
    route: '/delivery/order-management',
    position: { bottom: SPACING.XL2, right: SPACING.S },
  },
  pageContainerMarginBottom: 0,
}
